export default {
    clientid: process.env.VUE_APP_CLIENT_ID,
    redirecturl: process.env.VUE_APP_REDIRECT_URL,
    authority: 'https://login.microsoftonline.com/common',
    graphscopes: ['user.read'],
    graphendpoint: 'https://graph.microsoft.com/v1.0/me',
    appinsightsid: ''
}
  